import React from "react";
import styled from "styled-components";
import colors from "../../styles/colors";
import NumberInput from "../Number";
import remove from "../../images/remove.svg";
import down from "../../images/down.svg";
import up from "../../images/up.svg";
import {
    BlueButton,
    CloseButton,
    SaveButton,
    DisableCommentButton, GreenLargeButton
} from "../Button";
import Modal from "react-modal";
import en from "../../locales/en/translation.json";
import spn from "../../locales/sp/translation.json";
import swe from "../../locales/sw/translation.json";

class SortableList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mainLanguage: ''
        }
    }

    componentDidMount() {
        let mainLanguage = window.localStorage.getItem('language');
        this.setState({
            mainLanguage: mainLanguage
        })
    }

    render() {
        const {mainLanguage} = this.state;
        const readOnly = this.props.onSelect ? false : true;
        const {comment, currentIndex, modalIsOpen} = this.props;
        return (
            <>
                {this.props.loader ?
                    <NoFoundText>
                        Loading....
                    </NoFoundText> :
                    (this.props.items.length === 0) && (this.props.currentVersionIndex === 0 || this.props.currentVersionIndex === 1) ?
                        <NoFoundText>
                            Sorry! No Exercise found for this version
                        </NoFoundText> :
                        <List>
                            {this.props.items.map((item, index) =>
                                this.props.currentExerciseNumber === index ? (
                                    <>
                                        <ListItem
                                            id={index}
                                            data-id={index}
                                            key={index}
                                            selected={this.props.currentExerciseNumber === index}
                                            onClick={this.props.onSelect}
                                            onKeyDown={this.props.onArrowKeys}
                                            tabIndex={index + 1}
                                        >
                                            <ItemSelectedSecondaryAction>
                                                <IconButton icon={up} onClick={this.props.onMoveUp}/>
                                                <IconButton icon={down} onClick={this.props.onMoveDown}/>
                                            </ItemSelectedSecondaryAction>
                                            <ItemTitleArea>
                                                <ItemText>{item.name}</ItemText>
                                                {(this.props.currentVersionIndex === 1 ? (item.groupedShortTracK && !item.groupedShortTracKFirst) :
                                                    this.props.currentVersionIndex === 0 ? (item.groupedMultiTrack && !item.groupedMultiTrackFirst) : (item.grouped && !item.groupedFirst)) ? (
                                                    <ItemSubText>
                                                        <NumberInput
                                                            min={1}
                                                            max={20}
                                                            value={this.props.currentVersionIndex === 1 ? item.shortTrackRepeat : this.props.currentVersionIndex === 0 ? item.multiTrackRepeat : item.repeat}
                                                            onChange={(event) => {
                                                                this.props.currentVersionIndex === 1 ? this.props.onChangeRepeat('shortTrackRepeat', event, item) : this.props.currentVersionIndex === 0 ? this.props.onChangeRepeat('multiTrackRepeat', event, item) : this.props.onChangeRepeat('repeat', event, item)
                                                            }}
                                                        />
                                                        {item.repeatUnit}
                                                    </ItemSubText>
                                                ) : (
                                                    <ItemSubText>
                                                        <NumberInput
                                                            min={1}
                                                            max={10}
                                                            value={this.props.currentVersionIndex === 1 ? item.shortTrackSets : this.props.currentVersionIndex === 0 ? item.multiTrackSets : item.sets}
                                                            onChange={(event) => {
                                                                this.props.currentVersionIndex === 1 ? this.props.onChangeSets('shortTrackSets', event, item) : this.props.currentVersionIndex === 0 ? this.props.onChangeSets('multiTrackSets', event, item) : this.props.onChangeSets('sets', event, item)
                                                            }}
                                                        />{" "}
                                                        x
                                                        <NumberInput
                                                            min={1}
                                                            max={20}
                                                            value={this.props.currentVersionIndex === 1 ? item.shortTrackRepeat : this.props.currentVersionIndex === 0 ? item.multiTrackRepeat : item.repeat}
                                                            onChange={(event) => {
                                                                this.props.currentVersionIndex === 1 ? this.props.onChangeRepeat('shortTrackRepeat', event, item) : this.props.currentVersionIndex === 0 ? this.props.onChangeRepeat('multiTrackRepeat', event, item) : this.props.onChangeRepeat('repeat', event, item)
                                                            }}
                                                        />
                                                        {item.repeatUnit}
                                                    </ItemSubText>
                                                )}
                                            </ItemTitleArea>
                                            <ItemSelectedAction>
                                                <DeleteButton
                                                    onClick={(event) => this.props.currentVersionIndex === 1 ? this.props.onChangeShortTrack(event, item) : this.props.currentVersionIndex === 0 ? this.props.onChangeMultiTrack(event, item) : this.props.onRemoveExercise(event, item)}/>
                                            </ItemSelectedAction>
                                        </ListItem>
                                    </>
                                ) : (
                                    <>
                                        {currentIndex === index ? (
                                            <Modal
                                                isOpen={modalIsOpen}
                                                contentLabel="Example Modal"
                                                style={modalcustomStyle}
                                            >
                                                <ModalTitle>{item.name.toUpperCase()}</ModalTitle>
                                                <ModalBody>
                                                    <CommentBox
                                                        placeholder="Add Comment"
                                                        onChange={this.props.onCommentChange}
                                                        value={comment}
                                                    />
                                                </ModalBody>
                                                <ModalButtonContent>
                                                    {comment === "" ? (
                                                        <DisableCommentButton>
                                                            {mainLanguage === 'English' ? en.Spara : mainLanguage === 'Spanish' ? spn.Spara : swe.Spara}

                                                        </DisableCommentButton>
                                                    ) : (
                                                        <SaveButton
                                                            onClick={event => this.props.onSaveComment(index)}
                                                        >
                                                            {mainLanguage === 'English' ? en.Spara : mainLanguage === 'Spanish' ? spn.Spara : swe.Spara}
                                                        </SaveButton>
                                                    )}
                                                    <CloseButton onClick={this.props.onModelClose}>
                                                        {mainLanguage === 'English' ? en.Close : mainLanguage === 'Spanish' ? spn.Close : swe.Close}
                                                    </CloseButton>
                                                </ModalButtonContent>
                                            </Modal>
                                        ) : (
                                            ""
                                        )}

                                        <ListItem
                                            id={index}
                                            data-id={index}
                                            key={index}
                                            selected={this.props.currentExerciseNumber === index}
                                            onClick={this.props.onSelect}
                                            onKeyDown={this.props.onArrowKeys}
                                            tabIndex={index + 1}
                                        >
                                            <GroupButtonSwitch
                                                readOnly={readOnly}
                                                selected={this.props.currentVersionIndex === 1 ? item.groupedShortTracK : this.props.currentVersionIndex === 0 ? item.groupedMultiTrack : item.grouped}
                                                first={this.props.currentVersionIndex === 1 ? item.groupedShortTracKFirst : this.props.currentVersionIndex === 0 ? item.groupedMultiTrackFirst : item.groupedFirst}
                                                sets={this.props.currentVersionIndex === 1 ? item.shortTrackSets : this.props.currentVersionIndex === 0 ? item.multiTrackSets : item.sets}
                                                currentVersionIndex={this.props.currentVersionIndex}
                                                onClick={(event) => {
                                                    this.props.currentVersionIndex === 1 ? this.props.onChangeGrouped("groupedShortTracK", "groupedShortTracKFirst", event, item) : this.props.currentVersionIndex === 0 ? this.props.onChangeGrouped("groupedMultiTrack", "groupedMultiTrackFirst", event, item) : this.props.onChangeGrouped('grouped', 'groupedFirst', event, item)
                                                }}
                                                // onClick={(event)=>this.props.onChangeGrouped(this.props.currentVersionIndex===1? ("groupedShortTracK", "groupedShortTracKFirst",event):this.props.currentVersionIndex===0? ("groupedMultiTrack", "groupedMultiTrackFirst",event):'grouped','groupedFirst',event)}
                                            >
                                                {index + 1}
                                            </GroupButtonSwitch>
                                            <ItemTitleArea>
                                                <ItemText readOnly={readOnly}>{item.name}</ItemText>
                                                {(this.props.currentVersionIndex === 1 ? item.groupedShortTracK : this.props.currentVersionIndex === 0 ? item.groupedMultiTrack : item.grouped) ? (
                                                    <ItemSubText>
                                                        {(this.props.currentVersionIndex === 1) ? item.shortTrackRepeat : (this.props.currentVersionIndex === 0) ? item.multiTrackRepeat : item.repeat} {item.repeatUnit}
                                                    </ItemSubText>
                                                ) : (
                                                    <ItemSubText>
                                                        {(this.props.currentVersionIndex === 1) ? item.shortTrackSets :
                                                            (this.props.currentVersionIndex === 0) ? item.multiTrackSets : item.sets} x

                                                        {(this.props.currentVersionIndex === 1) ? item.shortTrackRepeat :
                                                            (this.props.currentVersionIndex === 0) ? item.multiTrackRepeat :
                                                                item.repeat} {item.repeatUnit}
                                                    </ItemSubText>
                                                )}
                                            </ItemTitleArea>

                                            {readOnly ? (
                                                ""
                                            ) : (
                                                <BlueButton
                                                    key={index}
                                                    onClick={event => this.props.OnModelOpen(event, index)}
                                                >
                                                    {mainLanguage === 'English' ? en.Kommentar : mainLanguage === 'Spanish' ? spn.Kommentar : swe.Kommentar}
                                                </BlueButton>
                                            )}

                                            {item.steps.map((exerciseImage) => {
                                                if(exerciseImage.image !== ""){
                                                    // let stringUrl = (exerciseImage.image.indexOf("data:image/") === 0 || exerciseImage.image.indexOf("https://") === 0) ? true : false
                                                    return (
                                                        <ParticularExercise
                                                            src={exerciseImage.image}
                                                            alt="Ta bort övning"
                                                        />
                                                    )
                                                }
                                                else{}
                                                })}
                                            <ItemAction>
                                                <TrackSwitch
                                                    readOnly={readOnly}
                                                    selected={item.multiTrack}
                                                    onClick={(event) => this.props.onChangeMultiTrack(event, item)}
                                                >
                                                    S
                                                </TrackSwitch>
                                                <TrackSwitch
                                                    readOnly={readOnly}
                                                    selected={item.shortTrack}
                                                    onClick={(event) => this.props.onChangeShortTrack(event, item)}
                                                >
                                                    M
                                                </TrackSwitch>
                                                <TrackSwitch
                                                    readOnly={readOnly}
                                                    selected={true}
                                                    onClick={event => {
                                                        event.stopPropagation();
                                                    }}
                                                >
                                                    L
                                                </TrackSwitch>
                                            </ItemAction>
                                        </ListItem>
                                    </>
                                )
                            )}
                        </List>
                }
            </>
        );
    }
}

const modalcustomStyle = {
    overlay: {
        backgroundColor: "#cecece8f"
    },
    content: {
        textAlign: "center",
        top: "50%",
        left: "50%",
        right: "50%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)"
    }
};

const List = styled.ol`
  margin: 0;
  padding: 0;
  font-size: 1rem;
  padding-bottom: 5rem;
`;

const ListItem = styled.li`
  display: flex;
  outline: none;
  align-items: center;
  width: 100%;
  height: 4rem;
  line-height: 1.5;
  list-style-type: none;
  text-transform: capitalize;
  background-color: ${props => props.selected ? colors.accent : colors.bright};
  color: ${props => (props.selected ? colors.bright : colors.first)};
  border-bottom: 1px solid #cccccc;
  cursor: pointer;
`;

const ModalButtonContent = styled.div`
margin-top:3px
  float: right;
`;
const ModalTitle = styled.h3``;
const ModalBody = styled.p``;

const CommentBox = styled.textarea`
  width: 90%;
  background-color: white;
  padding: 1rem;
  font-size: 1rem;
  border-radius: 2px;
  border: 2px solid ${colors.first};
  outline: none;
  color: ${colors.dark};
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;

  &::placeholder {
    color: ${colors.light};
  }
`;
const ItemAction = styled.div`
  display: flex;
  width: 15rem;
  justify-content: space-evenly;
`;

const ItemSelectedAction = styled.div`
  display: flex;
  width: 5rem;
  justify-content: space-evenly;
 
`;

const ItemSelectedSecondaryAction = styled.div`
  display: flex;
  width: 5rem;
  flex-direction: column;
  
`;

const IconButton = props => {
    return <ItemIcon src={props.icon} alt="" onClick={props.onClick}/>;
};

const DeleteButton = props => {
    return <ItemIcon src={remove} alt="Ta bort övning" onClick={props.onClick}/>;
};

const ItemIcon = styled.img`
  height: 1.5rem;
`;

const ItemTitleArea = styled.div`
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
`;

const ItemText = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 1rem;
  font-weight: 500;
  color: ${props => (props.readOnly ? colors.middle : colors.dark)};
  line-height: 1.3;
`;

const NoFoundText = styled.div`
width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 1rem;
  text-align:center;
  font-weight: 500;
  color: ${colors.dark};
  line-height: 1.3;
  margin-top:150px
`;

const ItemSubText = styled.div`
  width: 100%;
  font-size: 0.875rem;
  text-transform: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${colors.middle};
`;

const GroupRepeat = styled.div`
  width: 100%;
  height: 0.4rem;
  font-size: 0.875rem;
  color: ${colors.dark};
`;

const Index = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: ${props => (props.readOnly ? colors.middle : colors.first)};
`;

const GroupButtonSwitch = props => {
    // console.log('props====',props)
    return (
        <ItemGroupSwitch
            selected={props.selected}
            first={props.first}
            onClick={props.onClick}
        >
            <GroupRepeat selected={props.selected} first={props.first}>
                {props.first ? `${props.sets}x` : ""}
            </GroupRepeat>
            <Index readOnly={props.readOnly}>{props.children}</Index>
        </ItemGroupSwitch>
    );
};

const TrackSwitch = props => {
    return (
        <ItemTrackSwitch
            readOnly={props.readOnly}
            selected={props.selected}
            onClick={props.onClick}
        >
            {props.children}
        </ItemTrackSwitch>
    );
};

const ParticularExercise = styled.img`
  height: 50px;
  width: 50px;
`;

const ItemTrackSwitch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: initial;
  text-align: center;
  height: 2rem;
  width: 2rem;
  font-size: 1rem;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 2px;
  border: 2px solid transparent;
  background-clip: padding-box;
  color: ${colors.bright};
  background-color: ${props => props.selected ? props.readOnly ? colors.middle : colors.first : colors.light};
  padding: 1px;
  outline: none;
`;

const ItemGroupSwitch = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 4.5rem;
  padding-left: 0.1rem;
  color: ${colors.first};
  box-sizing: border-box;
  border-left: ${props =>
    props.selected
        ? `0.5rem solid ${colors.dark}`
        : "0.5rem solid transparent"};
  font-size: 2rem;
  font-weight: bold;
  transition: background-color 0.2s ease-out;

  &:hover {
    background-color: ${colors.light};
  }
`;

export default SortableList;



// WEBPACK FOOTER //
// ./src/Components/SortableList/index.js